<template>
  <v-app toolbar>
    <v-dialog v-model="info" fullscreen @click.native.stop="info = !info">
      <v-card class="infoDialog">
        <div class="menuIns">
          <v-icon dark>ion-navicon</v-icon>
        </div>
        <div class="menuInsTip"> <br>
          <strong>Chapters</strong><br>
          <small>Opens left navigation menu where you can skip book chapters</small>
        </div>
        <div class="socMenu">
          <v-icon dark>ion-social-linkedin</v-icon>
          <v-icon dark>ion-social-facebook</v-icon>
          <v-icon dark>ion-social-twitter</v-icon>
          <v-icon dark>ion-social-tumblr</v-icon>
          <v-icon dark>ion-social-pinterest</v-icon>
        </div>
        <div class="socMenuMob">
          <v-icon>ion-android-share-alt</v-icon>
        </div>
        <div class="socMenuTip"> <br>
          <strong>Social share buttons</strong><br>
          <small>Share book on your favorite social network</small>
        </div>
        <div class="resize-settings">
          <v-icon>ion-ios-gear-outline</v-icon>
        </div>
        <div class="resize-settings-tip"> <br>
          <strong>Settings button</strong><br>
          <small>Change visual settings</small>
        </div>
        <div class="left-button">
          <v-icon dark>ion-ios-arrow-left</v-icon>
        </div>
        <div class="left-button-tip"> <br>
          <strong>Left/Previous</strong><br>
          <small>Navigate previous page or chapter in book view.<br>On touch screen swipe right.</small>
        </div>
        <div class="right-button">
          <v-icon dark>ion-ios-arrow-right</v-icon>
        </div>
        <div class="right-button-tip"> <br>
          <strong>Right/Next</strong><br>
          <small>Navigate next page or chapter in book view.<br>On touch screen swipe left.</small>
        </div>
        <div class="buy-buttons">
          <v-icon dark>ion-bag</v-icon>
        </div>
        <div class="buy-buttons-mob">
          <v-icon>ion-bag</v-icon>
        </div>
        <div class="buy-buttons-tip"> <br>
          <strong>Buy links</strong><br>
          <small>Choose an online store to purchase this book</small>
        </div>
        <div class="headline">Instructions</div>
        <v-btn flat class="closeDialog" @click.native.stop="info = false" :ripple="false">Close</v-btn>
      </v-card>
    </v-dialog>
    <v-navigation-drawer class="menu" temporary hide-overlay @click.native.stop="drawer = !drawer" clipped v-model="drawer" enable-resize-watcher disable-route-watcher touchless>
      <v-list>
        <v-list-tile v-for="item in items" v-bind:href="item.path" :key="item.name" :to="item.path" exact :ripple="false" width="100%">
          <v-list-tile-action>
            <img height="55px"  v-bind:alt="item.alt" :src="item.image">
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title active>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer class="otherBooks" temporary hide-overlay @click.native.stop="otherBooks = !otherBooks" clipped v-model="otherBooks" enable-resize-watcher disable-route-watcher touchless>
      <v-list>
        <h6>Other books you might like:</h6>
        <v-list-tile v-for="book in books" v-bind:href="book.url" :key="book.title" target="_blank" :ripple="false" width="100%">
          <v-list-tile-action>
            <img v-bind:alt="book.alt" :src="book.img">
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title active>{{ book.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer class="settings-drawer" temporary hide-overlay clipped v-model="drawerRight" right enable-resize-watcher touchless>
      <v-list>
        <settings></settings>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer class="mini-bar" v-model="buyBar" mini-variant enable-resize-watcher touchless>
      <v-list :ripple="false">Shop:
        <v-list-tile v-for="buy in buys" v-bind:href="buy.url" :key="buy.title" v-on:click="buyClick(buy.url)"  target="_blank">
          <img v-bind:alt="buy.alt" :src="buy.img">
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="main-menu" fixed persistent>
      <v-btn flat class="main-menu-button" @click.native.stop="drawer = !drawer, info = false, buyMenu = false, socialMenu = false, drawerRight = false, otherBooks = false" :ripple="false">
        <v-icon>ion-navicon</v-icon>
      </v-btn>

      <v-btn v-if="books.length > 0" flat class="otherBooks-button" @click.native.stop="otherBooks = !otherBooks, info = false, buyMenu = false, socialMenu = false, drawerRight = false, drawer = false" :ripple="false" :key="booksChanged" >
        <v-icon>ion-ios-browsers-outline</v-icon>
      </v-btn>
      
      <v-toolbar class="desktop-social-btn" style="margin-left:5%">
        <v-btn flat v-for="social in socials" :key="social.title" v-bind:href="social.url" v-on:click="shareClick(social.title)" target="_blank" :ripple="false">
          <v-icon>{{ social.icon }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-btn flat class="mobile-buy-btn" @click.native.stop="buyMenu = !buyMenu, info = false, drawer = false, socialMenu = false, drawerRight = false, otherBooks = false">
        <v-icon>ion-bag</v-icon>
      </v-btn>
      <v-navigation-drawer class="buy-menu" width="100vw" height="auto" hide-overlay temporary clipped v-model="buyMenu" @click.stop="buyMenu = !buyMenu" disable-route-watcher touchless>
        <v-list>
          <span>Purchase this book: </span>
            <v-list-tile v-for="buy in buys" :key="buy.title" v-bind:href="buy.url" v-on:click="buyClick(buy.url)" target="_blank">
            <v-list-tile-action>
              <img v-bind:alt="buy.alt" :src="buy.img" />
            </v-list-tile-action>
            <v-list-tile-title v-html="buy.title"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-btn flat class="mobile-social-btn" @click.native.stop="socialMenu = !socialMenu, info = false, buyMenu = false, drawer = false, drawerRight = false, otherBooks = false">
        <v-icon>ion-android-share-alt</v-icon>
      </v-btn>
      <v-navigation-drawer class="social-menu" width="100vw" height="auto" hide-overlay temporary clipped v-model="socialMenu" @click.stop="socialMenu = !socialMenu" disable-route-watcher persistent touchless>
      <v-list>
          <span>Share this book: </span>
          <v-list-tile v-for="social in socials" :key="social.title" v-bind:href="social.url" v-on:click="shareClick(social.title)" target="_blank">
            <v-list-tile-action>
                <v-icon ></v-icon>
            </v-list-tile-action>
            <v-list-tile-title v-html="social.title"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        </v-navigation-drawer>
      <v-spacer></v-spacer>
      <v-btn flat class="info-btn" @click.native.stop="info = !info, drawer = false, buyMenu = false, socialMenu = false, drawerRight = false" :ripple="false">
        <v-icon>ion-ios-information-outline</v-icon>
      </v-btn>
      <v-btn flat class="settings-button" @click.native.stop="drawerRight = !drawerRight, info = false, buyMenu = false, socialMenu = false, drawer = false, otherBooks = false" :ripple="false">
        <v-icon>ion-ios-gear-outline</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid>
      <reader></reader>
    </v-container>
  </v-app>
</template>

<script>
import Reader from "./components/Reader.vue";
import Settings from "./components/Settings.vue";
import eventHub from "./event-hub.js";
import axios from 'axios';

export default {
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [
      ],
      booksChanged:'',
      socials: [
        {
          title: "LinkedIn",
          img: "static/img/linkedin-logo.svg",
          url:"https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/Fj1HdR/%3F1740638109375&title=Get%20Up%2C%20Stand%20Up&summary=The%20third%20picture%20book%20adaptation%20of%20one%20of%20Bob%20Marley%27s%20beloved%20songs%20that%20has%20a%20timely%20message%20for%20children%3A%20To%20counter%20injustice%2C%20lift%20others%20up%20with%20kindness%20and%20courage.A%20heartfelt%20and%20meaningful%20book%20that%20brings%20Bob%20Marley%27s%20music%20&source=LinkedIn",
          icon: "ion-social-linkedin"
        },
        {
          title: "Facebook",
          img: "static/img/facebook-logo.svg",
          url:"https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/Fj1HdR/%3F1740638109375",
          icon: "ion-social-facebook"
        },
        {
          title: "Twitter",
          img: "static/img/twitter-logo-silhouette.svg",
          url:
            "https://twitter.com/intent/tweet?text=The%20third%20picture%20book%20adaptation%20of%20one%20of%20Bob%20Marley%27s%20beloved%20songs%20that%20has%20a%20timely%20message%20for%20children%3A%20To%20counter%20injustice%2C%20lift%20oth%0Dhttps://textcafe.co/books/Fj1HdR/%3F1740638109375&amp;via=textcafecom",
          icon: "ion-social-twitter"
        },
        {
          title: "Tumblr",
          img: "static/img/tumblr-letter-logo.svg",
          url:
            "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/Fj1HdR/%3F1740638109375&posttype=link&caption=The%20third%20picture%20book%20adaptation%20of%20one%20of%20Bob%20Marley%27s%20beloved%20songs%20that%20has%20a%20timely%20message%20for%20children%3A%20To%20counter%20injustice%2C%20lift%20others%20up%20with%20kindness%20and%20courage.A%20heartfelt%20and%20meaningful%20book%20that%20brings%20Bob%20Marley%27s%20music%20",
          icon: "ion-social-tumblr"
        },
        {
          title: "Pinterest",
          img: "static/img/pinterest-logo.svg",
          url:
            "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/Fj1HdR/%3F1740638109375&description=The%20third%20picture%20book%20adaptation%20of%20one%20of%20Bob%20Marley%27s%20beloved%20songs%20that%20has%20a%20timely%20message%20for%20children%3A%20To%20counter%20injustice%2C%20lift%20others%20up%20with%20kindness%20and%20courage.A%20heartfelt%20and%20meaningful%20book%20that%20brings%20Bob%20Marley%27s%20music%20&media=https://textcafe.co/books/Fj1HdR/tc-custom/9781452175973.jpg",
          icon: "ion-social-pinterest"
        }
      ],
      buys: [
        { 
          title: 'Amazon US', 
          img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg', 
          url: 'https://www.amazon.com/s?k=9781452175973&i=stripbooks&linkCode=qs&tag=mobilebookcom-20', 
          alt : 'None' 
        },
      ],
      right: null,
      left: null
    }
  },
  mounted () {
    axios
      .get('https://www.textcafe.com/widget/get-samples.json?related=9781452175973')
      .then(response => (
        this.books = response.data.map((item) => {
          return {
            title: item.title,
            img: item.coverImagePath,
            url: item.socialUrl,
            alt: "This image is the cover for the book " + item.title
          };
        })
      ))
  },
  created: function() {
    this.$router.options.routes.forEach(route => {
      this.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        image: '/books/Fj1HdR/tc-custom/9781452175973.jpg?1740638109375',
        alt: 'Get Up, Stand Up'
      })
    })
    eventHub.$on("pageNum", newValue => {
      this.pageNum = newValue;
    })
    eventHub.$on("ttlPages", newValue => {
      this.ttlPages = newValue;
    })
  },
  watch: {
    $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },
    iSize: newValue => {
      eventHub.$emit("iSizeChanged", newValue);
    },
    books : newValue => {
      eventHub.$emit("booksChanged",Date.now())
    }
  },
  methods: {
    resetScroll() {
      const page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick(url) {
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url,
        // eventValue: 123
      })
    },
    shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network,
        // eventValue: 123
      })
    }
  },
  components: {
    settings: Settings,
    reader: Reader
  }
}
</script>

<style lang="stylus">
@import '../../node_modules/vuetify/src/stylus/main';
</style>

<style lang="css">
* {
  margin: 0;
  padding: 0; }

html {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
  scroll-behavior: smooth; }

body {
  font-family: 'Raleway', sans-serif;
  text-align: center;
  color: #f3f3f3;
  background-color: #504f4d;
  fill: currentColor !important;
  color: orange !important;
  height: 100%; }

main {
  padding: 0; }

h1,
h2 {
  font-weight: normal; }

ul {
  list-style-type: none;
  padding: 0; }
  ul li {
    display: inline-block;
    margin: 0 10px; }

a {
  color: #0074D9;
  text-decoration: none;
  transition: all .3s ease-out; }
  a:hover {
    color: #4BACB8; }

a:not([href]) {
  color: #2c3e50 !important; }
  a:not([href]):hover, a:not([href]):active, a:not([href]):focus {
    color: #2c3e50 !important; }

svg {
  border: 5px solid currentColor !important;
  fill: currentColor !important; }

table {
  border-collapse: collapse;
  border-width: 0.5pt;
  border-style: solid;
  border-color: grey; }

blockquote {
  border-left: 5px solid #4BACB8; }

.info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2c3e50;
  opacity: .5;
  z-index: 10; }

.dialog__content {
  z-index: 22 !important;
  opacity: .95 !important; }
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog {
    height: 100vh !important;
    font-size: 17px; }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog i {
      color: #f3f3f3;
      font-size: 25px; }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuIns {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 50px; }
      .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuIns i {
        padding: 12px 20px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuIns {
          width: 20vw; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuInsTip {
      position: absolute;
      top: 55px;
      left: 25px;
      width: 180px;
      padding: 0 10px 10px;
      border: 1px solid #f3f3f3;
      border-radius: 0 15px 15px 15px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuInsTip {
          font-size: 14px;
          width: 20vw;
          left: 0;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenu {
      position: absolute;
      top: 0;
      left: 100px;
      height: 50px;
      padding: 5px 0; }
      .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenu i {
        padding: 10px 18px;
        font-size: 17px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenu {
          display: none; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuMob {
      position: absolute;
      top: 0;
      left: 20vw;
      padding: 5px 0;
      width: 20vw; }
      .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuMob i {
        padding: 9px 18px;
        font-size: 20px;
        color: #f3f3f3; }
      @media screen and (min-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuMob {
          display: none; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuTip {
      position: absolute;
      top: 55px;
      left: 300px;
      padding: 0 10px 10px;
      width: 200px;
      border: 1px solid #f3f3f3;
      border-radius: 0 15px 15px 15px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuTip {
          font-size: 14px;
          left: 20vw;
          width: 20vw;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings {
      position: absolute;
      right: 0;
      top: 0;
      width: 70px;
      padding: 12px 0; }
      .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings i {
        color: #f3f3f3;
        font-size: 26px !important; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings {
          width: 20vw;
          left: 80vw; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings-tip {
      position: absolute;
      right: 25px;
      top: 55px;
      border: 1px solid #f3f3f3;
      border-radius: 15px 0 15px 15px;
      width: 220px;
      padding: 0 10px 8px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings-tip {
          font-size: 14px;
          left: 80vw;
          width: 20vw;
          top: 53px;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .info-button {
      position: absolute;
      top: 0;
      right: 71px;
      width: 50px;
      height: 50px;
      padding-top: 10px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .info-button {
          width: 20vw;
          left: 60vw; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .info-button-tip {
      position: absolute;
      top: 3px;
      right: 125px;
      width: 250px;
      border: 1px solid #f3f3f3;
      padding: 0 10px 10px;
      border-radius: 15px 0 15px 15px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .info-button-tip {
          font-size: 14px;
          left: 60vw;
          width: 20vw;
          top: 53px;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .left-button {
      position: absolute;
      top: 45vh;
      left: 100px;
      padding: 10px 20px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .left-button {
          left: 0;
          top: 55vh; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .left-button-tip {
      position: absolute;
      top: calc(45vh + 50px);
      left: 170px;
      border: 1px solid #f3f3f3;
      padding: 0 10px 10px;
      border-radius: 0 15px 15px 15px;
      width: 200px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .left-button-tip {
          width: 40vw;
          left: 3px;
          top: 65vh !important;
          font-size: 14px;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .right-button {
      position: absolute;
      top: 45vh;
      right: 100px;
      padding: 10px 20px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .right-button {
          right: 0;
          top: 55vh; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .right-button-tip {
      position: absolute;
      top: calc(45vh + 50px);
      right: 170px;
      border: 1px solid #f3f3f3;
      padding: 0 10px 10px;
      border-radius: 15px 0 15px 15px;
      width: 200px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .right-button-tip {
          width: 40vw;
          right: 3px;
          top: 65vh !important;
          font-size: 14px;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons {
      position: absolute;
      top: 45vh;
      left: 0;
      width: 80px;
      padding: 10px; }
      .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons i {
        font-size: 35px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons {
          display: none; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-mob {
      position: absolute;
      top: 0;
      left: 40vw;
      width: 20vw;
      padding: 10px; }
      .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-mob i {
        color: #f3f3f3; }
      @media screen and (min-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-mob {
          display: none; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-tip {
      position: absolute;
      top: calc(37vh + 135px);
      left: 5px;
      border: 1px solid #f3f3f3;
      border-radius: 0 15px 15px 15px;
      width: 120px;
      padding: 0 10px 10px; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-tip {
          font-size: 14px;
          top: 55px;
          left: 40vw;
          width: 20vw;
          padding: 5px; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .headline {
      margin: 0 auto;
      padding-top: 40vh;
      width: 100vw; }
      @media screen and (max-width: 768px) {
        .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .headline {
          padding-top: 50vh; } }
    .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .closeDialog {
      color: #f3f3f3;
      background: #4BACB8 !important;
      margin: 0 auto;
      padding: 10px;
      box-shadow: none;
      margin-top: 5px;
      border: 0; }

.overlay.overlay--active {
  background: #2C2F30;
  z-index: -1 !important; }

.infoDialog {
  background-color: #2C2F30 !important;
  color: #f3f3f3 !important; }

[data-tooltip][data-tooltip-location='bottom']:before {
  top: 100%;
  left: 50%;
  -webkit-transform: translate3d(-50%, -14px, 0) scale(0);
  transform: translate3d(-50%, -14px, 0) scale(0);
  -webkit-transform-origin: center top;
  transform-origin: left top; }

[data-tooltip]:before {
  color: #282c34;
  background: rgba(243, 243, 243, 0.5);
  background: #f3f3f3;
  box-shadow: none;
  z-index: 99; }

[data-tooltip]:hover:before {
  opacity: 1 !important; }

.main-menu-button[data-tooltip][data-tooltip-location='bottom']:before {
  left: 100%;
  top: 90%; }

.desktop-social-btn .btn[data-tooltip][data-tooltip-location='bottom']:before {
  left: 200%; }

.settings-button[data-tooltip][data-tooltip-location='bottom']:before {
  left: -0%; }

.lib-item-size {
  height: 30px; }
  .lib-item-size .input-group {
    display: inline-block;
    float: right;
    width: 100px; }
  .lib-item-size i {
    display: inline-block;
    cursor: pointer;
    margin: -14px 5px 0 0;
    padding: 15px;
    border: 1px solid rgba(75, 172, 184, 0); }
    .lib-item-size i:hover, .lib-item-size i:active, .lib-item-size i:focus {
      color: #4BACB8; }

.overlay,
.overlay--absolute,
.overlay--active {
  opacity: .5;
  z-index: 3;
  background-color: #2c3e50; }

nav {
  background-color: #f3f3f3 !important; }

.btn--active .btn__content:before,
.btn:hover .btn__content:before,
.btn:focus .btn__content:before {
  background-color: #f3f3f3; }

.main-menu.toolbar {
  z-index: 20 !important;
  box-shadow: none;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.2) !important; }

.main-menu {
  background-color: #f3f3f3 !important;
  height: 50px;
  z-index: 5 !important;
  padding: 0 10px 0 !important; }
  @media screen and (max-width: 500px) {
    .main-menu {
      padding: 0 !important; } }
  .main-menu .toolbar__content {
    height: auto; }
  .main-menu button {
    min-width: 50px !important;
    width: 70px;
    border-radius: 0;
    height: 50px !important;
    outline: 0;
    margin: 5px;
    margin: 0 auto !important;
    padding: 0 20px; }
    .main-menu button i {
      color: #0E0816 !important; }
    .main-menu button:hover, .main-menu button:active, .main-menu button:focus {
      opacity: 1; }
      .main-menu button:hover i, .main-menu button:active i, .main-menu button:focus i {
        color: #4BACB8 !important; }
    @media screen and (max-width: 768px) {
      .main-menu button {
        max-width: 15vw !important; } }

.main-menu ul > span {
  float: left;
  padding: 1rem; }

.navigation-drawer--right, .menu {
  z-index: 3 !important; }

.menu.navigation-drawer {
  transition: all .2s ease-in-out;
  background-color: #f3f3f3 !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.2) !important;
  padding-right: 10px; }
  .menu.navigation-drawer ul.list {
    background-color: #f3f3f3 !important;
    margin-top: 60px;
    margin-right: -25px;
    margin-left: 5px;
    padding-bottom: 80px; }
    .menu.navigation-drawer ul.list li a.list__tile,
    .menu.navigation-drawer ul.list .list__tile--highlighted {
      color: #504f4d !important;
      height: 75px;
      border: 1px solid rgba(75, 172, 184, 0); }
      .menu.navigation-drawer ul.list li a.list__tile:hover, .menu.navigation-drawer ul.list li a.list__tile:active, .menu.navigation-drawer ul.list li a.list__tile:focus,
      .menu.navigation-drawer ul.list .list__tile--highlighted:hover,
      .menu.navigation-drawer ul.list .list__tile--highlighted:active,
      .menu.navigation-drawer ul.list .list__tile--highlighted:focus {
        color: #4BACB8 !important;
        background-color: rgba(44, 62, 80, 0.05);
        border: 1px solid rgba(75, 172, 184, 0.25); }
      .menu.navigation-drawer ul.list li a.list__tile .list__tile__action i,
      .menu.navigation-drawer ul.list .list__tile--highlighted .list__tile__action i {
        color: #4BACB8 !important; }
    .menu.navigation-drawer ul.list li a.list__tile--active {
      color: #4BACB8 !important; }

.menu .menu__activator {
  font-size: 15px;
  background: rgba(44, 62, 80, 0);
  border: 1px solid rgba(75, 172, 184, 0);
  height: 50px; }
  .menu .menu__activator:hover, .menu .menu__activator:active, .menu .menu__activator:focus {
    color: #4BACB8 !important;
    background: rgba(44, 62, 80, 0.05) !important;
    border: 1px solid rgba(75, 172, 184, 0.25); }
  .menu .menu__activator .toolbar__title {
    margin-top: 7px; }

.menu .menu__activator--active {
  color: #4BACB8 !important;
  background: rgba(44, 62, 80, 0.05) !important;
  border: 1px solid rgba(75, 172, 184, 0.25); }

.toolbar__content > *:not(.btn):not(.toolbar__title):not(.menu):last-child,
.toolbar__extension > *:not(.btn):not(.toolbar__title):not(.menu):last-child {
  margin-right: 0; }

.toolbar__content > *:not(.btn):not(.toolbar__title):not(.menu):first-child,
.toolbar__extension > *:not(.btn):not(.toolbar__title):not(.menu):first-child {
  margin-left: 0;
  width: 85px; }

.btn {
  min-width: 0; }

.buy-menu {
  top: 50px; }

.buy-menu, .social-menu {
  width: 100vw;
  padding: 5px 30px;
  border: 1px solid rgba(75, 172, 184, 0);
  box-shadow: 0 0 0 6px 30px 5px rgba(0, 0, 0, 0.12) !important; }
  .buy-menu .list, .social-menu .list {
    z-index: 0 !important; }
  .buy-menu .list__tile:hover,
  .buy-menu .list__tile:active,
  .buy-menu .list__tile:focus, .social-menu .list__tile:hover,
  .social-menu .list__tile:active,
  .social-menu .list__tile:focus {
    color: #4BACB8 !important;
    background: rgba(44, 62, 80, 0.05) !important;
    border: 1px solid rgba(75, 172, 184, 0.25); }
    .buy-menu .list__tile:hover img svg,
    .buy-menu .list__tile:active img svg,
    .buy-menu .list__tile:focus img svg, .social-menu .list__tile:hover img svg,
    .social-menu .list__tile:active img svg,
    .social-menu .list__tile:focus img svg {
      fill: #4BACB8 !important; }
  .buy-menu .list__tile__action, .social-menu .list__tile__action {
    font-size: 20px; }
    .buy-menu .list__tile__action img, .social-menu .list__tile__action img {
      height: 22px; }
      .buy-menu .list__tile__action img svg, .social-menu .list__tile__action img svg {
        fill: #4BACB8 !important; }

.buy-menu.navigation-drawer--close:not(.navigation--permanent).navigation-drawer:not(.navigation-drawer--right),
.social-menu.navigation-drawer--close:not(.navigation--permanent).navigation-drawer:not(.navigation-drawer--right) {
  transform: translate3d(0, calc(-100% - 100px), 0); }

.otherBooks ul.list {
  margin-top: 55px;
  margin-right: -18px;
  padding-right: 18px;
  padding-left: 18px;
  padding-bottom: 100px;
  background-color: #f3f3f3 !important; }
  @media screen and (max-width: 480px) {
    .otherBooks ul.list {
      margin-right: 0;
      padding-right: 0;
      padding-left: 0; } }
  .otherBooks ul.list h6 {
    font-size: 18px; }
  .otherBooks ul.list li {
    max-height: 200px;
    padding: 10px 0; }
    .otherBooks ul.list li .list__tile {
      display: block;
      height: auto;
      padding-top: 10px; }
      .otherBooks ul.list li .list__tile:hover {
        background: rgba(75, 172, 184, 0.25);
        color: #4BACB8; }
      .otherBooks ul.list li .list__tile .list__tile__action {
        height: auto;
        text-align: right;
        margin-bottom: 20px;
        margin-top: 10px; }
        .otherBooks ul.list li .list__tile .list__tile__action img {
          max-width: 200px;
          margin: 0 auto; }
      .otherBooks ul.list li .list__tile .list__tile__content .list__tile__title {
        text-align: center;
        font-size: 18px; 
        overflow-x: visible;
        white-space: normal;}

.HC,
.HC-button,
.otherBooks-button,
.main-menu-button,
.info-btn,
.settings-button,
.mobile-social-btn,
.mobile-buy-btn {
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  border: 0 !important;
  width: 50px !important; }
  .HC:focus, .HC:active, .HC:hover,
  .HC-button:focus,
  .HC-button:active,
  .HC-button:hover,
  .otherBooks-button:focus,
  .otherBooks-button:active,
  .otherBooks-button:hover,
  .main-menu-button:focus,
  .main-menu-button:active,
  .main-menu-button:hover,
  .info-btn:focus,
  .info-btn:active,
  .info-btn:hover,
  .settings-button:focus,
  .settings-button:active,
  .settings-button:hover,
  .mobile-social-btn:focus,
  .mobile-social-btn:active,
  .mobile-social-btn:hover,
  .mobile-buy-btn:focus,
  .mobile-buy-btn:active,
  .mobile-buy-btn:hover {
    background-color: #f3f3f3; }
    .HC:focus i.icon, .HC:active i.icon, .HC:hover i.icon,
    .HC-button:focus i.icon,
    .HC-button:active i.icon,
    .HC-button:hover i.icon,
    .otherBooks-button:focus i.icon,
    .otherBooks-button:active i.icon,
    .otherBooks-button:hover i.icon,
    .main-menu-button:focus i.icon,
    .main-menu-button:active i.icon,
    .main-menu-button:hover i.icon,
    .info-btn:focus i.icon,
    .info-btn:active i.icon,
    .info-btn:hover i.icon,
    .settings-button:focus i.icon,
    .settings-button:active i.icon,
    .settings-button:hover i.icon,
    .mobile-social-btn:focus i.icon,
    .mobile-social-btn:active i.icon,
    .mobile-social-btn:hover i.icon,
    .mobile-buy-btn:focus i.icon,
    .mobile-buy-btn:active i.icon,
    .mobile-buy-btn:hover i.icon {
      color: #4BACB8 !important; }
  @media screen and (max-width: 768px) {
    .HC .HC-button,
    .HC-button .HC-button,
    .otherBooks-button .HC-button,
    .main-menu-button .HC-button,
    .info-btn .HC-button,
    .settings-button .HC-button,
    .mobile-social-btn .HC-button,
    .mobile-buy-btn .HC-button {
      margin-right: -10px !important; }
    .HC:focus, .HC:active, .HC:hover,
    .HC-button:focus,
    .HC-button:active,
    .HC-button:hover,
    .otherBooks-button:focus,
    .otherBooks-button:active,
    .otherBooks-button:hover,
    .main-menu-button:focus,
    .main-menu-button:active,
    .main-menu-button:hover,
    .info-btn:focus,
    .info-btn:active,
    .info-btn:hover,
    .settings-button:focus,
    .settings-button:active,
    .settings-button:hover,
    .mobile-social-btn:focus,
    .mobile-social-btn:active,
    .mobile-social-btn:hover,
    .mobile-buy-btn:focus,
    .mobile-buy-btn:active,
    .mobile-buy-btn:hover {
      background-color: #f3f3f3; }
      .HC:focus i.icon, .HC:active i.icon, .HC:hover i.icon,
      .HC-button:focus i.icon,
      .HC-button:active i.icon,
      .HC-button:hover i.icon,
      .otherBooks-button:focus i.icon,
      .otherBooks-button:active i.icon,
      .otherBooks-button:hover i.icon,
      .main-menu-button:focus i.icon,
      .main-menu-button:active i.icon,
      .main-menu-button:hover i.icon,
      .info-btn:focus i.icon,
      .info-btn:active i.icon,
      .info-btn:hover i.icon,
      .settings-button:focus i.icon,
      .settings-button:active i.icon,
      .settings-button:hover i.icon,
      .mobile-social-btn:focus i.icon,
      .mobile-social-btn:active i.icon,
      .mobile-social-btn:hover i.icon,
      .mobile-buy-btn:focus i.icon,
      .mobile-buy-btn:active i.icon,
      .mobile-buy-btn:hover i.icon {
        color: #4BACB8 !important;
        text-shadow: none; } }

.HC-button img {
  max-height: 25px !important;
  margin-top: 7px !important; }

.HC-footer-button {
  margin: 0; }

.mobile-social-btn {
  display: none;
  padding: 0;
  margin: 0 !important;
  height: 49px !important;
  box-shadow: none;
  border: 0 !important; }
  .mobile-social-btn i {
    opacity: .7 !important; }
  .mobile-social-btn:focus, .mobile-social-btn:active, .mobile-social-btn:hover {
    box-shadow: none; }

.mobile-buy-btn {
  display: none;
  padding: 0;
  margin: 0 !important;
  height: 49px !important;
  box-shadow: none;
  border: 0 !important;
  font-weight: bolder !important; }
  .mobile-buy-btn i {
    opacity: .7 !important; }
  .mobile-buy-btn:focus, .mobile-buy-btn:active, .mobile-buy-btn:hover {
    background-color: rgba(0, 0, 0, 0);
    box-shadow: none; }

.desktop-social-btn {
  box-shadow: none; }
  .desktop-social-btn a.btn {
    margin: 0; }
    .desktop-social-btn a.btn i.icon {
      color: #282c34 !important;
      font-size: 20px; }
    .desktop-social-btn a.btn:hover i.icon, .desktop-social-btn a.btn:active i.icon, .desktop-social-btn a.btn:focus i.icon {
      color: #4BACB8 !important; }

.navigation-drawer__border {
  display: none; }

.mini-bar.navigation-drawer--mini-variant {
  height: auto !important;
  margin: 0;
  margin-top: 60px;
  padding: 0;
  top: 25%;
  transform: translate3d(0, -50%, 0);
  z-index: 2;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.2) !important; }
  .mini-bar.navigation-drawer--mini-variant ul.list {
    background: #f3f3f3 !important;
    height: auto;
    overflow: hidden; }
    .mini-bar.navigation-drawer--mini-variant ul.list a {
      width: 100%; }
      .mini-bar.navigation-drawer--mini-variant ul.list a:hover, .mini-bar.navigation-drawer--mini-variant ul.list a:active, .mini-bar.navigation-drawer--mini-variant ul.list a:focus {
        background: rgba(75, 172, 184, 0.1) !important; }
      .mini-bar.navigation-drawer--mini-variant ul.list a img {
        width: 35px;
        display: block;
        margin: 10px auto; }
  @media screen and (min-width: 768px) {
    .mini-bar.navigation-drawer--mini-variant {
      display: block; } }

.settings-drawer {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.2) !important; }
  .settings-drawer ul.list {
    background-color: #f3f3f3 !important; }
    .settings-drawer ul.list button#black {
      border: 1px solid #f3f3f3 !important; }

.container {
  padding: 0; }

.font1, .font2 {
  font-size: 1em; }

.menu__content {
  width: 200px;
  left: auto !important;
  right: 37px;
  top: 100px !important;
  z-index: 6 !important; }

.input-group--overflow .input-group__input:before,
.input-group--editable .input-group__input:before,
.input-group--segmented .input-group__input:before,
.input-group__details:before {
  height: 0; }

.application--light .input-group.input-group--dirty .input-group__selections__comma {
  color: #4BACB8;
  font-weight: bold;
  letter-spacing: 3px; }

.input-group__selections {
  overflow: visible !important; }

.bold-font {
  font-weight: bold;
  color: #4BACB8;
  font-size: 17px; }

.list li {
  width: 100%;
  margin: 0; }

.input-group--select {
  padding: 0;
  height: 30px; }

.radio {
  width: 50%;
  float: left;
  padding: 0;
  padding-top: 20px; }

.input-group__details:after {
  background-color: #4BACB8; }

.slider {
  height: 0; }

.slider__thumb {
  cursor: pointer; }

.input-group--slider.input-group--dirty .slider__thumb {
  background-color: #4BACB8;
  width: 25px;
  height: 25px; }

.input-group--slider.input-group--dirty .slider__thumb--label {
  background-color: #4BACB8; }

.application--light .input-group--slider:not(.input-group--dirty).input-group--ticks .slider__thumb-container .slider__thumb {
  background-color: #4BACB8; }

.application--light .input-group--slider:not(.input-group--dirty):not(.input-group--ticks):focus .slider__thumb {
  background-color: #4BACB8;
  border: 4px solid #4BACB8 !important; }

.input-group--slider:not(.input-group--disabled).input-group--dirty .slider__track-fill {
  background-color: #4BACB8; }

.input-group--slider {
  height: 30px;
  padding-bottom: 0; }

.application--light .input-group.input-group--selection-controls.radio, .application--light .input-group.input-group--selection-controls.checkbox {
  color: #4BACB8; }

.input-group--selection-controls {
  height: 60px; }

.library {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  padding-right: 20px;
  margin-right: -20px; }

.nav-btn {
  overflow: hidden;
  position: absolute;
  top: 0;
  padding: 20px;
  transition: .3s ease-in-out;
  height: 100vh;
  width: 50%;
  margin: 0;
  z-index: 0; }
  .nav-btn:hover {
    opacity: 1 !important; }
    .nav-btn:hover .icon {
      color: #4bacb8 !important;
      text-shadow: 2px 1px 10px rgba(75, 172, 184, 0.5); }
  .nav-btn img {
    height: 50px; }
  .nav-btn .icon {
    height: 100%;
    position: absolute;
    top: 0;
    font-size: 5rem;
    color: rgba(75, 172, 184, 0.75) !important;
    opacity: 1 !important; }

.nav-btn .btn__content:before {
  background-color: rgba(0, 0, 0, 0.75); }

.nav-btn:active .btn__content:before, .nav-btn:focus .btn__content:before, .nav-btn:hover .btn__content:before {
  background-color: #000; }

.left {
  left: 0; }
  .left .icon {
    left: 20% !important; }
    @media screen and (min-width: 1024px) {
      .left .icon {
        left: 100px; } }
  .left img {
    transform: rotate(180deg); }

.right {
  right: 0; }
  .right .icon {
    right: 20% !important; }

.wrap {
  filter: brightness(100%); }

.progress-linear {
  position: absolute;
  margin: 0;
  padding: 0;
  bottom: 0 !important;
  z-index: 11;
  height: 5px !important;
  box-shadow: inset -1px 0 2px 5px rgba(0, 0, 0, 0.1) !important; }
  .progress-linear .progress-linear__bar {
    background: rgba(243, 243, 243, 0.1);
    opacity: .75; }
    .progress-linear .progress-linear__bar .progress-linear__bar__determinate {
      background-color: #4BACB8; }

footer {
  position: fixed;
  bottom: 0;
  padding: 0 20px !important;
  padding-top: 3px !important;
  left: 0;
  width: 100%;
  z-index: 10 !important;
  background: #f3f3f3 !important;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px rgba(0, 0, 0, 0.2), 0 1px 10px rgba(0, 0, 0, 0.2);
  height: auto !important;
  font-size: 22px;
  font-family: 'Old Standard TT'; }
  footer .HC-footer-button {
    height: 29px;
    left: 0;
    position: absolute; }
    footer .HC-footer-button img {
      height: 20px; }
    @media screen and (max-width: 768px) {
      footer .HC-footer-button {
        position: relative;
        float: left; } }

.book-content {
  background-color: #f3f3f3;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.2);
  max-width: 100%;
  min-width: 500px;
  z-index: 2 !important;
  margin-top: 50px;
  margin-bottom: 100px;
  margin-left: 50%;
  transform: translate3d(-50%, 0, 0);
  -webkit-transform: translate3d(-50%, 0, 0);
  transition: all 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  height: calc(100vh - 75px);
  margin-bottom: 50px !important;
  width: 40%;
  touch-action: pinch-zoom; }
  .book-content .rezz {
    position: absolute;
    top: 5px;
    right: 20px;
    z-index: 10;
    width: 35px;
    height: 35px;
    color: #504f4d;
    cursor: pointer; }
    .book-content .rezz:hover {
      color: #4BACB8; }
  .book-content .slide-right-enter-active,
  .book-content .slide-right-leave-active,
  .book-content .slide-left-enter-active,
  .book-content .slide-left-leave-active,
  .book-content .slide-right-enter,
  .book-content .slide-left-leave-to,
  .book-content .slide-right-enter-to,
  .book-content .slide-left-leave,
  .book-content .slide-right-leave,
  .book-content .slide-left-enter-to,
  .book-content .slide-left-enter,
  .book-content .slide-right-leave-to,
  .book-content .book-page {
    position: relative;
    width: 100% !important;
    height: 100% !important;
    overflow-x: hidden !important;
    transition: all 0.35s cubic-bezier(0, 0.74, 0.36, 1);
    text-align: left;
    font-family: 'Old Standard TT';
    padding: 0;
    z-index: 1 !important;
    scroll-behavior: smooth; }
    .book-content .slide-right-enter-active h1,
    .book-content .slide-right-enter-active h2,
    .book-content .slide-right-enter-active h3,
    .book-content .slide-right-enter-active h4,
    .book-content .slide-right-enter-active h5,
    .book-content .slide-right-enter-active h6,
    .book-content .slide-right-leave-active h1,
    .book-content .slide-right-leave-active h2,
    .book-content .slide-right-leave-active h3,
    .book-content .slide-right-leave-active h4,
    .book-content .slide-right-leave-active h5,
    .book-content .slide-right-leave-active h6,
    .book-content .slide-left-enter-active h1,
    .book-content .slide-left-enter-active h2,
    .book-content .slide-left-enter-active h3,
    .book-content .slide-left-enter-active h4,
    .book-content .slide-left-enter-active h5,
    .book-content .slide-left-enter-active h6,
    .book-content .slide-left-leave-active h1,
    .book-content .slide-left-leave-active h2,
    .book-content .slide-left-leave-active h3,
    .book-content .slide-left-leave-active h4,
    .book-content .slide-left-leave-active h5,
    .book-content .slide-left-leave-active h6,
    .book-content .slide-right-enter h1,
    .book-content .slide-right-enter h2,
    .book-content .slide-right-enter h3,
    .book-content .slide-right-enter h4,
    .book-content .slide-right-enter h5,
    .book-content .slide-right-enter h6,
    .book-content .slide-left-leave-to h1,
    .book-content .slide-left-leave-to h2,
    .book-content .slide-left-leave-to h3,
    .book-content .slide-left-leave-to h4,
    .book-content .slide-left-leave-to h5,
    .book-content .slide-left-leave-to h6,
    .book-content .slide-right-enter-to h1,
    .book-content .slide-right-enter-to h2,
    .book-content .slide-right-enter-to h3,
    .book-content .slide-right-enter-to h4,
    .book-content .slide-right-enter-to h5,
    .book-content .slide-right-enter-to h6,
    .book-content .slide-left-leave h1,
    .book-content .slide-left-leave h2,
    .book-content .slide-left-leave h3,
    .book-content .slide-left-leave h4,
    .book-content .slide-left-leave h5,
    .book-content .slide-left-leave h6,
    .book-content .slide-right-leave h1,
    .book-content .slide-right-leave h2,
    .book-content .slide-right-leave h3,
    .book-content .slide-right-leave h4,
    .book-content .slide-right-leave h5,
    .book-content .slide-right-leave h6,
    .book-content .slide-left-enter-to h1,
    .book-content .slide-left-enter-to h2,
    .book-content .slide-left-enter-to h3,
    .book-content .slide-left-enter-to h4,
    .book-content .slide-left-enter-to h5,
    .book-content .slide-left-enter-to h6,
    .book-content .slide-left-enter h1,
    .book-content .slide-left-enter h2,
    .book-content .slide-left-enter h3,
    .book-content .slide-left-enter h4,
    .book-content .slide-left-enter h5,
    .book-content .slide-left-enter h6,
    .book-content .slide-right-leave-to h1,
    .book-content .slide-right-leave-to h2,
    .book-content .slide-right-leave-to h3,
    .book-content .slide-right-leave-to h4,
    .book-content .slide-right-leave-to h5,
    .book-content .slide-right-leave-to h6,
    .book-content .book-page h1,
    .book-content .book-page h2,
    .book-content .book-page h3,
    .book-content .book-page h4,
    .book-content .book-page h5,
    .book-content .book-page h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all; }
    .book-content .slide-right-enter-active h1,
    .book-content .slide-right-leave-active h1,
    .book-content .slide-left-enter-active h1,
    .book-content .slide-left-leave-active h1,
    .book-content .slide-right-enter h1,
    .book-content .slide-left-leave-to h1,
    .book-content .slide-right-enter-to h1,
    .book-content .slide-left-leave h1,
    .book-content .slide-right-leave h1,
    .book-content .slide-left-enter-to h1,
    .book-content .slide-left-enter h1,
    .book-content .slide-right-leave-to h1,
    .book-content .book-page h1 {
      font-size: 55px;
      line-height: 60px;
      margin-bottom: 30px; }
    .book-content .slide-right-enter-active h1.chapter,
    .book-content .slide-right-leave-active h1.chapter,
    .book-content .slide-left-enter-active h1.chapter,
    .book-content .slide-left-leave-active h1.chapter,
    .book-content .slide-right-enter h1.chapter,
    .book-content .slide-left-leave-to h1.chapter,
    .book-content .slide-right-enter-to h1.chapter,
    .book-content .slide-left-leave h1.chapter,
    .book-content .slide-right-leave h1.chapter,
    .book-content .slide-left-enter-to h1.chapter,
    .book-content .slide-left-enter h1.chapter,
    .book-content .slide-right-leave-to h1.chapter,
    .book-content .book-page h1.chapter {
      font-size: 55px;
      width: 100%; }
    .book-content .slide-right-enter-active img,
    .book-content .slide-right-leave-active img,
    .book-content .slide-left-enter-active img,
    .book-content .slide-left-leave-active img,
    .book-content .slide-right-enter img,
    .book-content .slide-left-leave-to img,
    .book-content .slide-right-enter-to img,
    .book-content .slide-left-leave img,
    .book-content .slide-right-leave img,
    .book-content .slide-left-enter-to img,
    .book-content .slide-left-enter img,
    .book-content .slide-right-leave-to img,
    .book-content .book-page img {
      page-break-before: auto;
      page-break-after: auto;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      display: block; }
    .book-content .slide-right-enter-active ul, .book-content .slide-right-enter-active ul > li,
    .book-content .slide-right-leave-active ul,
    .book-content .slide-right-leave-active ul > li,
    .book-content .slide-left-enter-active ul,
    .book-content .slide-left-enter-active ul > li,
    .book-content .slide-left-leave-active ul,
    .book-content .slide-left-leave-active ul > li,
    .book-content .slide-right-enter ul,
    .book-content .slide-right-enter ul > li,
    .book-content .slide-left-leave-to ul,
    .book-content .slide-left-leave-to ul > li,
    .book-content .slide-right-enter-to ul,
    .book-content .slide-right-enter-to ul > li,
    .book-content .slide-left-leave ul,
    .book-content .slide-left-leave ul > li,
    .book-content .slide-right-leave ul,
    .book-content .slide-right-leave ul > li,
    .book-content .slide-left-enter-to ul,
    .book-content .slide-left-enter-to ul > li,
    .book-content .slide-left-enter ul,
    .book-content .slide-left-enter ul > li,
    .book-content .slide-right-leave-to ul,
    .book-content .slide-right-leave-to ul > li,
    .book-content .book-page ul,
    .book-content .book-page ul > li {
      float: left; }
    .book-content .slide-right-enter-active ul li,
    .book-content .slide-right-leave-active ul li,
    .book-content .slide-left-enter-active ul li,
    .book-content .slide-left-leave-active ul li,
    .book-content .slide-right-enter ul li,
    .book-content .slide-left-leave-to ul li,
    .book-content .slide-right-enter-to ul li,
    .book-content .slide-left-leave ul li,
    .book-content .slide-right-leave ul li,
    .book-content .slide-left-enter-to ul li,
    .book-content .slide-left-enter ul li,
    .book-content .slide-right-leave-to ul li,
    .book-content .book-page ul li {
      width: 100%; }
    .book-content .slide-right-enter-active .publisherInfo,
    .book-content .slide-right-enter-active .authorInfo,
    .book-content .slide-right-leave-active .publisherInfo,
    .book-content .slide-right-leave-active .authorInfo,
    .book-content .slide-left-enter-active .publisherInfo,
    .book-content .slide-left-enter-active .authorInfo,
    .book-content .slide-left-leave-active .publisherInfo,
    .book-content .slide-left-leave-active .authorInfo,
    .book-content .slide-right-enter .publisherInfo,
    .book-content .slide-right-enter .authorInfo,
    .book-content .slide-left-leave-to .publisherInfo,
    .book-content .slide-left-leave-to .authorInfo,
    .book-content .slide-right-enter-to .publisherInfo,
    .book-content .slide-right-enter-to .authorInfo,
    .book-content .slide-left-leave .publisherInfo,
    .book-content .slide-left-leave .authorInfo,
    .book-content .slide-right-leave .publisherInfo,
    .book-content .slide-right-leave .authorInfo,
    .book-content .slide-left-enter-to .publisherInfo,
    .book-content .slide-left-enter-to .authorInfo,
    .book-content .slide-left-enter .publisherInfo,
    .book-content .slide-left-enter .authorInfo,
    .book-content .slide-right-leave-to .publisherInfo,
    .book-content .slide-right-leave-to .authorInfo,
    .book-content .book-page .publisherInfo,
    .book-content .book-page .authorInfo {
      float: left;
      width: 100%; }
    .book-content .slide-right-enter-active .publisherInfo p,
    .book-content .slide-right-leave-active .publisherInfo p,
    .book-content .slide-left-enter-active .publisherInfo p,
    .book-content .slide-left-leave-active .publisherInfo p,
    .book-content .slide-right-enter .publisherInfo p,
    .book-content .slide-left-leave-to .publisherInfo p,
    .book-content .slide-right-enter-to .publisherInfo p,
    .book-content .slide-left-leave .publisherInfo p,
    .book-content .slide-right-leave .publisherInfo p,
    .book-content .slide-left-enter-to .publisherInfo p,
    .book-content .slide-left-enter .publisherInfo p,
    .book-content .slide-right-leave-to .publisherInfo p,
    .book-content .book-page .publisherInfo p {
      width: 100%;
      display: block;
      float: none; }
    .book-content .slide-right-enter-active .coverImage, .book-content .slide-right-enter-active .seperator img, .book-content .slide-right-enter-active img,
    .book-content .slide-right-leave-active .coverImage,
    .book-content .slide-right-leave-active .seperator img,
    .book-content .slide-right-leave-active img,
    .book-content .slide-left-enter-active .coverImage,
    .book-content .slide-left-enter-active .seperator img,
    .book-content .slide-left-enter-active img,
    .book-content .slide-left-leave-active .coverImage,
    .book-content .slide-left-leave-active .seperator img,
    .book-content .slide-left-leave-active img,
    .book-content .slide-right-enter .coverImage,
    .book-content .slide-right-enter .seperator img,
    .book-content .slide-right-enter img,
    .book-content .slide-left-leave-to .coverImage,
    .book-content .slide-left-leave-to .seperator img,
    .book-content .slide-left-leave-to img,
    .book-content .slide-right-enter-to .coverImage,
    .book-content .slide-right-enter-to .seperator img,
    .book-content .slide-right-enter-to img,
    .book-content .slide-left-leave .coverImage,
    .book-content .slide-left-leave .seperator img,
    .book-content .slide-left-leave img,
    .book-content .slide-right-leave .coverImage,
    .book-content .slide-right-leave .seperator img,
    .book-content .slide-right-leave img,
    .book-content .slide-left-enter-to .coverImage,
    .book-content .slide-left-enter-to .seperator img,
    .book-content .slide-left-enter-to img,
    .book-content .slide-left-enter .coverImage,
    .book-content .slide-left-enter .seperator img,
    .book-content .slide-left-enter img,
    .book-content .slide-right-leave-to .coverImage,
    .book-content .slide-right-leave-to .seperator img,
    .book-content .slide-right-leave-to img,
    .book-content .book-page .coverImage,
    .book-content .book-page .seperator img,
    .book-content .book-page img {
      width: 100%;
      height: auto;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid; }
    .book-content .slide-right-enter-active span.drop-cap,
    .book-content .slide-right-leave-active span.drop-cap,
    .book-content .slide-left-enter-active span.drop-cap,
    .book-content .slide-left-leave-active span.drop-cap,
    .book-content .slide-right-enter span.drop-cap,
    .book-content .slide-left-leave-to span.drop-cap,
    .book-content .slide-right-enter-to span.drop-cap,
    .book-content .slide-left-leave span.drop-cap,
    .book-content .slide-right-leave span.drop-cap,
    .book-content .slide-left-enter-to span.drop-cap,
    .book-content .slide-left-enter span.drop-cap,
    .book-content .slide-right-leave-to span.drop-cap,
    .book-content .book-page span.drop-cap {
      font-size: 2.8em;
      line-height: 1.3em;
      margin-right: 10px;
      margin-bottom: -.5em;
      float: left; }
    .book-content .slide-right-enter-active .Inset,
    .book-content .slide-right-leave-active .Inset,
    .book-content .slide-left-enter-active .Inset,
    .book-content .slide-left-leave-active .Inset,
    .book-content .slide-right-enter .Inset,
    .book-content .slide-left-leave-to .Inset,
    .book-content .slide-right-enter-to .Inset,
    .book-content .slide-left-leave .Inset,
    .book-content .slide-right-leave .Inset,
    .book-content .slide-left-enter-to .Inset,
    .book-content .slide-left-enter .Inset,
    .book-content .slide-right-leave-to .Inset,
    .book-content .book-page .Inset {
      width: 100%; }
    .book-content .slide-right-enter-active .subA,
    .book-content .slide-right-leave-active .subA,
    .book-content .slide-left-enter-active .subA,
    .book-content .slide-left-leave-active .subA,
    .book-content .slide-right-enter .subA,
    .book-content .slide-left-leave-to .subA,
    .book-content .slide-right-enter-to .subA,
    .book-content .slide-left-leave .subA,
    .book-content .slide-right-leave .subA,
    .book-content .slide-left-enter-to .subA,
    .book-content .slide-left-enter .subA,
    .book-content .slide-right-leave-to .subA,
    .book-content .book-page .subA {
      font-weight: bold;
      line-height: 3rem; }
    .book-content .slide-right-enter-active ol,
    .book-content .slide-right-leave-active ol,
    .book-content .slide-left-enter-active ol,
    .book-content .slide-left-leave-active ol,
    .book-content .slide-right-enter ol,
    .book-content .slide-left-leave-to ol,
    .book-content .slide-right-enter-to ol,
    .book-content .slide-left-leave ol,
    .book-content .slide-right-leave ol,
    .book-content .slide-left-enter-to ol,
    .book-content .slide-left-enter ol,
    .book-content .slide-right-leave-to ol,
    .book-content .book-page ol {
      margin-left: 20px; }
    .book-content .slide-right-enter-active ol > li:last-child,
    .book-content .slide-right-leave-active ol > li:last-child,
    .book-content .slide-left-enter-active ol > li:last-child,
    .book-content .slide-left-leave-active ol > li:last-child,
    .book-content .slide-right-enter ol > li:last-child,
    .book-content .slide-left-leave-to ol > li:last-child,
    .book-content .slide-right-enter-to ol > li:last-child,
    .book-content .slide-left-leave ol > li:last-child,
    .book-content .slide-right-leave ol > li:last-child,
    .book-content .slide-left-enter-to ol > li:last-child,
    .book-content .slide-left-enter ol > li:last-child,
    .book-content .slide-right-leave-to ol > li:last-child,
    .book-content .book-page ol > li:last-child {
      margin-bottom: 16px; }
    .book-content .slide-right-enter-active td,
    .book-content .slide-right-leave-active td,
    .book-content .slide-left-enter-active td,
    .book-content .slide-left-leave-active td,
    .book-content .slide-right-enter td,
    .book-content .slide-left-leave-to td,
    .book-content .slide-right-enter-to td,
    .book-content .slide-left-leave td,
    .book-content .slide-right-leave td,
    .book-content .slide-left-enter-to td,
    .book-content .slide-left-enter td,
    .book-content .slide-right-leave-to td,
    .book-content .book-page td {
      border-right: 1px solid grey;
      border-bottom: 1px solid grey;
      padding: 10px;
      page-break-before: auto;
      page-break-after: auto;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      font-size: 12px; }
      .book-content .slide-right-enter-active td:first-child,
      .book-content .slide-right-leave-active td:first-child,
      .book-content .slide-left-enter-active td:first-child,
      .book-content .slide-left-leave-active td:first-child,
      .book-content .slide-right-enter td:first-child,
      .book-content .slide-left-leave-to td:first-child,
      .book-content .slide-right-enter-to td:first-child,
      .book-content .slide-left-leave td:first-child,
      .book-content .slide-right-leave td:first-child,
      .book-content .slide-left-enter-to td:first-child,
      .book-content .slide-left-enter td:first-child,
      .book-content .slide-right-leave-to td:first-child,
      .book-content .book-page td:first-child {
        border-left: 1px solid grey; }
    .book-content .slide-right-enter-active .headerRow,
    .book-content .slide-right-leave-active .headerRow,
    .book-content .slide-left-enter-active .headerRow,
    .book-content .slide-left-leave-active .headerRow,
    .book-content .slide-right-enter .headerRow,
    .book-content .slide-left-leave-to .headerRow,
    .book-content .slide-right-enter-to .headerRow,
    .book-content .slide-left-leave .headerRow,
    .book-content .slide-right-leave .headerRow,
    .book-content .slide-left-enter-to .headerRow,
    .book-content .slide-left-enter .headerRow,
    .book-content .slide-right-leave-to .headerRow,
    .book-content .book-page .headerRow {
      border: 1px solid grey; }
    .book-content .slide-right-enter-active .subheader,
    .book-content .slide-right-leave-active .subheader,
    .book-content .slide-left-enter-active .subheader,
    .book-content .slide-left-leave-active .subheader,
    .book-content .slide-right-enter .subheader,
    .book-content .slide-left-leave-to .subheader,
    .book-content .slide-right-enter-to .subheader,
    .book-content .slide-left-leave .subheader,
    .book-content .slide-right-leave .subheader,
    .book-content .slide-left-enter-to .subheader,
    .book-content .slide-left-enter .subheader,
    .book-content .slide-right-leave-to .subheader,
    .book-content .book-page .subheader {
      font-size: .9em;
      height: auto;
      display: block;
      width: 100%;
      font-style: italic; }
    .book-content .slide-right-enter-active #ncover,
    .book-content .slide-right-enter-active #nendpaper,
    .book-content .slide-right-enter-active #ntitle-page,
    .book-content .slide-right-enter-active .toc-nav,
    .book-content .slide-right-enter-active #nin1,
    .book-content .slide-right-leave-active #ncover,
    .book-content .slide-right-leave-active #nendpaper,
    .book-content .slide-right-leave-active #ntitle-page,
    .book-content .slide-right-leave-active .toc-nav,
    .book-content .slide-right-leave-active #nin1,
    .book-content .slide-left-enter-active #ncover,
    .book-content .slide-left-enter-active #nendpaper,
    .book-content .slide-left-enter-active #ntitle-page,
    .book-content .slide-left-enter-active .toc-nav,
    .book-content .slide-left-enter-active #nin1,
    .book-content .slide-left-leave-active #ncover,
    .book-content .slide-left-leave-active #nendpaper,
    .book-content .slide-left-leave-active #ntitle-page,
    .book-content .slide-left-leave-active .toc-nav,
    .book-content .slide-left-leave-active #nin1,
    .book-content .slide-right-enter #ncover,
    .book-content .slide-right-enter #nendpaper,
    .book-content .slide-right-enter #ntitle-page,
    .book-content .slide-right-enter .toc-nav,
    .book-content .slide-right-enter #nin1,
    .book-content .slide-left-leave-to #ncover,
    .book-content .slide-left-leave-to #nendpaper,
    .book-content .slide-left-leave-to #ntitle-page,
    .book-content .slide-left-leave-to .toc-nav,
    .book-content .slide-left-leave-to #nin1,
    .book-content .slide-right-enter-to #ncover,
    .book-content .slide-right-enter-to #nendpaper,
    .book-content .slide-right-enter-to #ntitle-page,
    .book-content .slide-right-enter-to .toc-nav,
    .book-content .slide-right-enter-to #nin1,
    .book-content .slide-left-leave #ncover,
    .book-content .slide-left-leave #nendpaper,
    .book-content .slide-left-leave #ntitle-page,
    .book-content .slide-left-leave .toc-nav,
    .book-content .slide-left-leave #nin1,
    .book-content .slide-right-leave #ncover,
    .book-content .slide-right-leave #nendpaper,
    .book-content .slide-right-leave #ntitle-page,
    .book-content .slide-right-leave .toc-nav,
    .book-content .slide-right-leave #nin1,
    .book-content .slide-left-enter-to #ncover,
    .book-content .slide-left-enter-to #nendpaper,
    .book-content .slide-left-enter-to #ntitle-page,
    .book-content .slide-left-enter-to .toc-nav,
    .book-content .slide-left-enter-to #nin1,
    .book-content .slide-left-enter #ncover,
    .book-content .slide-left-enter #nendpaper,
    .book-content .slide-left-enter #ntitle-page,
    .book-content .slide-left-enter .toc-nav,
    .book-content .slide-left-enter #nin1,
    .book-content .slide-right-leave-to #ncover,
    .book-content .slide-right-leave-to #nendpaper,
    .book-content .slide-right-leave-to #ntitle-page,
    .book-content .slide-right-leave-to .toc-nav,
    .book-content .slide-right-leave-to #nin1,
    .book-content .book-page #ncover,
    .book-content .book-page #nendpaper,
    .book-content .book-page #ntitle-page,
    .book-content .book-page .toc-nav,
    .book-content .book-page #nin1 {
      display: block;
      width: 100%; }
    .book-content .slide-right-enter-active .inner_page h1.chapter0,
    .book-content .slide-right-enter-active .inner_page h1.chapter1,
    .book-content .slide-right-enter-active .inner_page h1.section,
    .book-content .slide-right-leave-active .inner_page h1.chapter0,
    .book-content .slide-right-leave-active .inner_page h1.chapter1,
    .book-content .slide-right-leave-active .inner_page h1.section,
    .book-content .slide-left-enter-active .inner_page h1.chapter0,
    .book-content .slide-left-enter-active .inner_page h1.chapter1,
    .book-content .slide-left-enter-active .inner_page h1.section,
    .book-content .slide-left-leave-active .inner_page h1.chapter0,
    .book-content .slide-left-leave-active .inner_page h1.chapter1,
    .book-content .slide-left-leave-active .inner_page h1.section,
    .book-content .slide-right-enter .inner_page h1.chapter0,
    .book-content .slide-right-enter .inner_page h1.chapter1,
    .book-content .slide-right-enter .inner_page h1.section,
    .book-content .slide-left-leave-to .inner_page h1.chapter0,
    .book-content .slide-left-leave-to .inner_page h1.chapter1,
    .book-content .slide-left-leave-to .inner_page h1.section,
    .book-content .slide-right-enter-to .inner_page h1.chapter0,
    .book-content .slide-right-enter-to .inner_page h1.chapter1,
    .book-content .slide-right-enter-to .inner_page h1.section,
    .book-content .slide-left-leave .inner_page h1.chapter0,
    .book-content .slide-left-leave .inner_page h1.chapter1,
    .book-content .slide-left-leave .inner_page h1.section,
    .book-content .slide-right-leave .inner_page h1.chapter0,
    .book-content .slide-right-leave .inner_page h1.chapter1,
    .book-content .slide-right-leave .inner_page h1.section,
    .book-content .slide-left-enter-to .inner_page h1.chapter0,
    .book-content .slide-left-enter-to .inner_page h1.chapter1,
    .book-content .slide-left-enter-to .inner_page h1.section,
    .book-content .slide-left-enter .inner_page h1.chapter0,
    .book-content .slide-left-enter .inner_page h1.chapter1,
    .book-content .slide-left-enter .inner_page h1.section,
    .book-content .slide-right-leave-to .inner_page h1.chapter0,
    .book-content .slide-right-leave-to .inner_page h1.chapter1,
    .book-content .slide-right-leave-to .inner_page h1.section,
    .book-content .book-page .inner_page h1.chapter0,
    .book-content .book-page .inner_page h1.chapter1,
    .book-content .book-page .inner_page h1.section {
      float: left; }
    .book-content .slide-right-enter-active .book-title,
    .book-content .slide-right-enter-active .heading,
    .book-content .slide-right-leave-active .book-title,
    .book-content .slide-right-leave-active .heading,
    .book-content .slide-left-enter-active .book-title,
    .book-content .slide-left-enter-active .heading,
    .book-content .slide-left-leave-active .book-title,
    .book-content .slide-left-leave-active .heading,
    .book-content .slide-right-enter .book-title,
    .book-content .slide-right-enter .heading,
    .book-content .slide-left-leave-to .book-title,
    .book-content .slide-left-leave-to .heading,
    .book-content .slide-right-enter-to .book-title,
    .book-content .slide-right-enter-to .heading,
    .book-content .slide-left-leave .book-title,
    .book-content .slide-left-leave .heading,
    .book-content .slide-right-leave .book-title,
    .book-content .slide-right-leave .heading,
    .book-content .slide-left-enter-to .book-title,
    .book-content .slide-left-enter-to .heading,
    .book-content .slide-left-enter .book-title,
    .book-content .slide-left-enter .heading,
    .book-content .slide-right-leave-to .book-title,
    .book-content .slide-right-leave-to .heading,
    .book-content .book-page .book-title,
    .book-content .book-page .heading {
      margin-top: 40px; }
    .book-content .slide-right-enter-active p,
    .book-content .slide-right-leave-active p,
    .book-content .slide-left-enter-active p,
    .book-content .slide-left-leave-active p,
    .book-content .slide-right-enter p,
    .book-content .slide-left-leave-to p,
    .book-content .slide-right-enter-to p,
    .book-content .slide-left-leave p,
    .book-content .slide-right-leave p,
    .book-content .slide-left-enter-to p,
    .book-content .slide-left-enter p,
    .book-content .slide-right-leave-to p,
    .book-content .book-page p {
      display: block !important;
      margin: 5px 0 !important; }
    .book-content .slide-right-enter-active p.copy,
    .book-content .slide-right-enter-active p.copy1,
    .book-content .slide-right-leave-active p.copy,
    .book-content .slide-right-leave-active p.copy1,
    .book-content .slide-left-enter-active p.copy,
    .book-content .slide-left-enter-active p.copy1,
    .book-content .slide-left-leave-active p.copy,
    .book-content .slide-left-leave-active p.copy1,
    .book-content .slide-right-enter p.copy,
    .book-content .slide-right-enter p.copy1,
    .book-content .slide-left-leave-to p.copy,
    .book-content .slide-left-leave-to p.copy1,
    .book-content .slide-right-enter-to p.copy,
    .book-content .slide-right-enter-to p.copy1,
    .book-content .slide-left-leave p.copy,
    .book-content .slide-left-leave p.copy1,
    .book-content .slide-right-leave p.copy,
    .book-content .slide-right-leave p.copy1,
    .book-content .slide-left-enter-to p.copy,
    .book-content .slide-left-enter-to p.copy1,
    .book-content .slide-left-enter p.copy,
    .book-content .slide-left-enter p.copy1,
    .book-content .slide-right-leave-to p.copy,
    .book-content .slide-right-leave-to p.copy1,
    .book-content .book-page p.copy,
    .book-content .book-page p.copy1 {
      text-align: center; }
    .book-content .slide-right-enter-active small,
    .book-content .slide-right-leave-active small,
    .book-content .slide-left-enter-active small,
    .book-content .slide-left-leave-active small,
    .book-content .slide-right-enter small,
    .book-content .slide-left-leave-to small,
    .book-content .slide-right-enter-to small,
    .book-content .slide-left-leave small,
    .book-content .slide-right-leave small,
    .book-content .slide-left-enter-to small,
    .book-content .slide-left-enter small,
    .book-content .slide-right-leave-to small,
    .book-content .book-page small {
      margin-left: -5px; }
    .book-content .slide-right-enter-active span.small,
    .book-content .slide-right-leave-active span.small,
    .book-content .slide-left-enter-active span.small,
    .book-content .slide-left-leave-active span.small,
    .book-content .slide-right-enter span.small,
    .book-content .slide-left-leave-to span.small,
    .book-content .slide-right-enter-to span.small,
    .book-content .slide-left-leave span.small,
    .book-content .slide-right-leave span.small,
    .book-content .slide-left-enter-to span.small,
    .book-content .slide-left-enter span.small,
    .book-content .slide-right-leave-to span.small,
    .book-content .book-page span.small {
      font-size: 0.8em; }
    .book-content .slide-right-enter-active h2.title,
    .book-content .slide-right-leave-active h2.title,
    .book-content .slide-left-enter-active h2.title,
    .book-content .slide-left-leave-active h2.title,
    .book-content .slide-right-enter h2.title,
    .book-content .slide-left-leave-to h2.title,
    .book-content .slide-right-enter-to h2.title,
    .book-content .slide-left-leave h2.title,
    .book-content .slide-right-leave h2.title,
    .book-content .slide-left-enter-to h2.title,
    .book-content .slide-left-enter h2.title,
    .book-content .slide-right-leave-to h2.title,
    .book-content .book-page h2.title {
      font-size: 34px !important;
      font-weight: 500 !important;
      line-height: 1 !important;
      letter-spacing: .02em !important; }
    .book-content .slide-right-enter-active .warning,
    .book-content .slide-right-leave-active .warning,
    .book-content .slide-left-enter-active .warning,
    .book-content .slide-left-leave-active .warning,
    .book-content .slide-right-enter .warning,
    .book-content .slide-left-leave-to .warning,
    .book-content .slide-right-enter-to .warning,
    .book-content .slide-left-leave .warning,
    .book-content .slide-right-leave .warning,
    .book-content .slide-left-enter-to .warning,
    .book-content .slide-left-enter .warning,
    .book-content .slide-right-leave-to .warning,
    .book-content .book-page .warning {
      background-color: #ffc107 !important;
      border-color: #ffc107 !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      page-break-before: auto;
      page-break-after: auto;
      border-radius: 10px;
      padding: 5px 30px;
      border: 1px solid #ffc107 !important;
      border-radius: 10px; }
      .book-content .slide-right-enter-active .warning .title,
      .book-content .slide-right-leave-active .warning .title,
      .book-content .slide-left-enter-active .warning .title,
      .book-content .slide-left-leave-active .warning .title,
      .book-content .slide-right-enter .warning .title,
      .book-content .slide-left-leave-to .warning .title,
      .book-content .slide-right-enter-to .warning .title,
      .book-content .slide-left-leave .warning .title,
      .book-content .slide-right-leave .warning .title,
      .book-content .slide-left-enter-to .warning .title,
      .book-content .slide-left-enter .warning .title,
      .book-content .slide-right-leave-to .warning .title,
      .book-content .book-page .warning .title {
        margin-bottom: 10px; }
      .book-content .slide-right-enter-active .warning p,
      .book-content .slide-right-leave-active .warning p,
      .book-content .slide-left-enter-active .warning p,
      .book-content .slide-left-leave-active .warning p,
      .book-content .slide-right-enter .warning p,
      .book-content .slide-left-leave-to .warning p,
      .book-content .slide-right-enter-to .warning p,
      .book-content .slide-left-leave .warning p,
      .book-content .slide-right-leave .warning p,
      .book-content .slide-left-enter-to .warning p,
      .book-content .slide-left-enter .warning p,
      .book-content .slide-right-leave-to .warning p,
      .book-content .book-page .warning p {
        margin-bottom: 20px; }

::-webkit-scrollbar {
  position: relative;
  width: 5px; }

::-webkit-scrollbar:after {
  content: '';
  position: absolute;
  width: 5px;
  transform: translateX(-50%);
  border-right: 1px dotted #4BACB8 !important;
  z-index: 100 !important; }

::-webkit-scrollbar-track {
  background: rgba(241, 241, 241, 0); }

::-webkit-scrollbar-thumb {
  background: rgba(75, 172, 184, 0.5); }

::-webkit-scrollbar-thumb:hover {
  background: #4BACB8; }

.lib-item-size .input-group {
  width: 150px;
  position: absolute;
  right: 0;
  top: 50px;
  background-color: #f3f3f3;
  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.1), -5px 0 15px rgba(0, 0, 0, 0.1);
  padding: 20px 10px; }

.settings {
  color: #2c3e50;
  padding: 20px;
  margin-top: 30px; }
  .settings button.settings-link {
    outline: 0;
    border: 0;
    cursor: pointer;
    background: 0;
    margin-top: 10px;
    color: #2c3e50;
    font-size: 26px;
    border: 1px solid #dadada;
    padding: 0 1rem; }
    .settings button.settings-link:hover {
      color: #fb8c00;
      border: 1px solid #fb8c00; }
  .settings .settings-container {
    color: #2c3e50;
    position: absolute;
    top: 57px;
    left: calc(50% - 255px);
    background: #f3f3f3;
    border-radius: 1px;
    padding: 30px;
    width: 450px;
    box-shadow: 0 2px 4px -1px rgba(44, 62, 80, 0.01), 0 4px 5px rgba(44, 62, 80, 0.01), 0 1px 10px rgba(44, 62, 80, 0.01);
    text-align: center;
    padding-bottom: 0;
    z-index: -10; }
  .settings .settings-list #reloadBookBtn {
    border: 1px solid #b6b5b3;
    border-radius: 100px;
    width: 40px;
    height: 40px; }
    .settings .settings-list #reloadBookBtn i {
      color: #4BACB8 !important;
      transform: scale(1.1); }
    .settings .settings-list #reloadBookBtn:hover, .settings .settings-list #reloadBookBtn:active, .settings .settings-list #reloadBookBtn:focus {
      border: 1px solid #6a6966; }
      .settings .settings-list #reloadBookBtn:hover i, .settings .settings-list #reloadBookBtn:active i, .settings .settings-list #reloadBookBtn:focus i {
        transform: scale(1); }
  .settings .settings-list .menu__content--dropdown {
    box-shadow: 0 !important; }
  .settings .settings-list hr {
    border-color: rgba(44, 62, 80, 0.02);
    width: 100%; }
  .settings .settings-list li {
    margin-right: 10px;
    display: block;
    width: 100%;
    padding: 20px; }
    .settings .settings-list li:first-child {
      margin-top: 10px;
      padding-bottom: 0; }
    .settings .settings-list li span {
      float: left;
      font-size: 1.1rem; }
    .settings .settings-list li #colors {
      margin: 0;
      padding: 0;
      width: 100%; }
      .settings .settings-list li #colors button {
        font-size: 1.25rem;
        padding: 5px 10px;
        border: 1px solid #4BACB8 !important;
        border-radius: 1px;
        width: 85px;
        height: 50px;
        display: inline-block;
        margin: 0 0 3px; }
      .settings .settings-list li #colors #white {
        color: #2c3e50;
        border: 1px solid white !important;
        background-color: #f3f3f3 !important; }
        .settings .settings-list li #colors #white:hover, .settings .settings-list li #colors #white:active, .settings .settings-list li #colors #white:focus {
          color: #2c3e50;
          border: 1px solid white !important;
          background-color: #f3f3f3 !important; }
      .settings .settings-list li #colors #black {
        color: #f3f3f3;
        border: 1px solid #f3f3f3 !important;
        background-color: #2C2F30 !important; }
        .settings .settings-list li #colors #black:hover, .settings .settings-list li #colors #black:active, .settings .settings-list li #colors #black:focus {
          color: #f3f3f3;
          background-color: #2C2F30 !important; }
      .settings .settings-list li #colors #sepia {
        color: #2c3e50;
        border: 1px solid #dcc1a7 !important;
        background-color: #dcc1a7 !important; }
        .settings .settings-list li #colors #sepia:hover, .settings .settings-list li #colors #sepia:active, .settings .settings-list li #colors #sepia:focus {
          color: #2c3e50;
          border: 1px solid #dcc1a7 !important;
          background-color: #dcc1a7 !important; }
    .settings .settings-list li .input-group .input-group--dirty .input-group .input-group--slider .input-group--ticks .input-group--active {
      color: blue !important;
      background-color: blue; }
  .settings .settings-list input[type="radio"] {
    width: 30px;
    float: none;
    width: 20px; }

.application--light .input-group.input-group--selection-controls.radio, .application--light .input-group.input-group--selection-controls.checkbox {
  margin-bottom: 20px; }

.input-group--overflow .input-group__input:hover, .input-group--editable .input-group__input:hover, .input-group--segmented .input-group__input:hover {
  background: inherit; }

.input-group--overflow.input-group--focused .input-group__input, .input-group--editable.input-group--focused .input-group__input, .input-group--segmented.input-group--focused .input-group__input {
  box-shadow: none;
  background: inherit; }

.white {
  color: #2c3e50 !important;
  background-color: #f3f3f3 !important; }
  .white .book-page, .white .bookTitle, .white .authorName, .white .publisherName, .white h1, .white h2, .white h3, .white h4, .white h5, .white h6, .white p.subheader {
    color: #2c3e50 !important; }

.black {
  color: #c4c4c4 !important;
  background-color: #2C2F30 !important; }
  .black .book-page, .black .bookTitle, .black .authorName, .black .publisherName, .black h1, .black h2, .black h3, .black h4, .black h5, .black h6, .black p.subheader {
    color: #c4c4c4 !important; }
  .black a {
    color: #4BACB8;
    opacity: .7;
    transition: opacity .3s ease-out; }
    .black a:hover, .black a:active, .black a:focus {
      opacity: 1; }
  .black a:not([href]) {
    color: #c4c4c4 !important; }
    .black a:not([href]):hover, .black a:not([href]):active, .black a:not([href]):focus {
      color: #c4c4c4 !important;
      opacity: .7; }

.sepia {
  color: #2c3e50 !important;
  background-color: #dcc1a7 !important; }
  .sepia .book-page, .sepia .bookTitle, .sepia .authorName, .sepia .publisherName, .sepia h1, .sepia h2, .sepia h3, .sepia h4, .sepia h5, .sepia h6, .sepia p.subheader {
    color: #2c3e50 !important; }

.application {
  background-color: #233140; }

.list-btn {
  display: block;
  width: 100%; }

.navigation-drawer--permanent.navigation-drawer--clipped,
.navigation-drawer--persistent.navigation-drawer--clipped,
.navigation-drawer--permanent.navigation-drawer--floating,
.navigation-drawer--persistent.navigation-drawer--floating {
  margin-top: 50px;
  max-height: calc(100vh - 50px); }

.navigation-drawer--permanent.navigation-drawer--clipped ~ .toolbar,
.navigation-drawer--persistent.navigation-drawer--clipped ~ .toolbar,
.navigation-drawer--permanent.navigation-drawer--floating ~ .toolbar,
.navigation-drawer--persistent.navigation-drawer--floating ~ .toolbar,
.navigation-drawer--permanent.navigation-drawer--clipped ~ .footer.footer--fixed,
.navigation-drawer--persistent.navigation-drawer--clipped ~ .footer.footer--fixed,
.navigation-drawer--permanent.navigation-drawer--floating ~ .footer.footer--fixed,
.navigation-drawer--persistent.navigation-drawer--floating ~ .footer.footer--fixed,
.navigation-drawer--permanent.navigation-drawer--clipped ~ .footer.footer--absolute,
.navigation-drawer--persistent.navigation-drawer--clipped ~ .footer.footer--absolute,
.navigation-drawer--permanent.navigation-drawer--floating ~ .footer.footer--absolute,
.navigation-drawer--persistent.navigation-drawer--floating ~ .footer.footer--absolute {
  z-index: 5; }

.navigation-drawer {
  overflow: hidden;
  z-index: 3;
  margin-right: -20px;
  padding: 0; }
  .navigation-drawer ul.list {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%; }
    .navigation-drawer ul.list li {
      padding-top: 10px; }

.Old-Cabin {
  font-family: 'Old Standard TT' !important; }
  .Old-Cabin h1,
  .Old-Cabin h2,
  .Old-Cabin h3,
  .Old-Cabin h4,
  .Old-Cabin h5,
  .Old-Cabin h6 {
    font-family: 'Cabin' !important; }

.Raleway-Bitter {
  font-family: 'Raleway' !important; }
  .Raleway-Bitter h1,
  .Raleway-Bitter h2,
  .Raleway-Bitter h3,
  .Raleway-Bitter h4,
  .Raleway-Bitter h5,
  .Raleway-Bitter h6 {
    font-family: 'Bitter' !important; }

.Ubuntu-Abel {
  font-family: 'Ubuntu' !important; }
  .Ubuntu-Abel h1,
  .Ubuntu-Abel h2,
  .Ubuntu-Abel h3,
  .Ubuntu-Abel h4,
  .Ubuntu-Abel h5,
  .Ubuntu-Abel h6 {
    font-family: 'Abel' !important; }

.Droid-Abril {
  font-family: 'Droid Sans' !important; }
  .Droid-Abril h1,
  .Droid-Abril h2,
  .Droid-Abril h3,
  .Droid-Abril h4,
  .Droid-Abril h5,
  .Droid-Abril h6 {
    font-family: 'Abril Fatface' !important; }

.Garamond-Clicker {
  font-family: 'EB Garamond' !important; }
  .Garamond-Clicker h1,
  .Garamond-Clicker h2,
  .Garamond-Clicker h3,
  .Garamond-Clicker h4,
  .Garamond-Clicker h5,
  .Garamond-Clicker h6 {
    font-family: 'Clicker Script' !important; }

.Alice-Playfair {
  font-family: 'Alice' !important; }
  .Alice-Playfair h1,
  .Alice-Playfair h2,
  .Alice-Playfair h3,
  .Alice-Playfair h4,
  .Alice-Playfair h5,
  .Alice-Playfair h6 {
    font-family: 'Playfair Display' !important; }

.Judson-Quando {
  font-family: 'Judson' !important; }
  .Judson-Quando h1,
  .Judson-Quando h2,
  .Judson-Quando h3,
  .Judson-Quando h4,
  .Judson-Quando h5,
  .Judson-Quando h6 {
    font-family: 'Quando' !important; }

h1, .bookTitle, .book-content .book-page h1 {
  font-size: 55px !important;
  line-height: 60px !important;
  float: none !important;
  margin-top: 5vh;
  display: inline-block !important; }

.bookDescription {
  font-style: italic; }

.authorName {
  font-size: 2.5rem; }

.authorDescription {
  font-style: italic; }

.publisherName {
  font-size: 2rem;
  margin-top: 20px; }

.slide-leave-active,
.slide-enter-active {
  transition: all .3s ease; }

.slide-enter {
  transform: translate3d(100%, 0, 0);
  -webkit-transform: translate3d(100%, 0, 0);
  opacity: 0; }

.slide-leave-to {
  transform: translate3d(-100%, 0, 0);
  -webkit-transform: translate3d(-100%, 0, 0);
  opacity: 0; }

.menu .menu__activator--active {
  color: #4BACB8 !important;
  background: rgba(44, 62, 80, 0) !important;
  border: 0n; }

.inner_page h1.section,
.inner_page h1.chapter1,
.inner_page h1.chapter0 {
  font-size: 42px; }

.authorInfo p > span,
.authorInfo p > em {
  font-size: 33px;
  font-family: fontFamily;
  font-style: italic;
  background-color: #f3f3f3 !important; }

.toc span.black {
  background-color: #f3f3f3 !important;
  color: #2c3e50 !important; }

code, kbd {
  white-space: normal; }
  code:after, code:before, kbd:after, kbd:before {
    contain: ''; }

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  position: absolute; }

.slide-right-enter,
.slide-left-leave-to {
  transform: translate3d(-100%, 0, 0);
  transition: transform 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  position: absolute; }

.slide-right-enter-to,
.slide-left-leave,
.slide-right-leave,
.slide-left-enter-to {
  transform: translate3d(0, 0, 0);
  transition: transform 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  position: absolute; }

.slide-left-enter,
.slide-right-leave-to {
  transform: translate3d(100%, 0, 0);
  transition: transform 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  position: absolute; }

.touch-swipe {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block; }

.touch-swipe.hidden {
  display: none; }

.frontMatter h1 {
  font-size: 50px !important; }

span.dropcap {
  float: left; }

span.drop-cap {
  font-size: 2.8em;
  line-height: 1em;
  padding-top: 4px;
  padding-right: 8px;
  padding-left: 3px;
  float: left; }

#toc ol, .hide1 ol {
  list-style: none; }

#toc ol li:nth-child(n+1):nth-child(n+5) {
  text-align: left; }

#toc ol li.toc {
  padding-left: 0 !important; }

#toc li:nth-child(1),
#toc li:nth-child(2),
#toc li:nth-child(3),
#toc li:nth-child(4),
#toc li:nth-child(5) {
  padding-left: 0; }

#nav ol {
  list-style: none; }

.bullett img.block,
.bullet img.block {
  margin-left: 0; }

p.c15 span {
  float: left; }

p.P_Body_Text > span {
  font-size: 2.5em;
  font-weight: bolder;
  display: inline-block;
  margin-right: -2px; }

p.section-break {
  text-align: center; }

.chapter-title-corner-decorations table {
  display: none; }

.smallcaps {
  text-transform: lowercase !important;
  margin-left: -5px !important; }

.copyright {
  text-align: center; }

.authorInfo p > span,
.authorInfo p > em {
  font-size: 33px;
  font-family: fontFamily;
  font-style: italic;
  background-color: #f3f3f3 !important; }

.toc span.black {
  background-color: #f3f3f3 !important;
  color: #2c3e50 !important; }

@media screen and (max-width: 768px) {
  body {
    overflow: hidden; }
  nav.main-menu .HC,
  .toolbar .HC,
  .toolbar--fixed .HC,
  .toolbar__content .HC {
    width: 40px !important; }
  .columns-setting,
  .width-setting {
    display: none !important; }
  .nav-btn {
    display: none !important; }
  ul#colors button {
    border: 0; }
  ul#colors #white {
    color: #2c3e50;
    border: 1px solid #f3f3f3 !important;
    background-color: #f3f3f3 !important; }
  ul#colors #black {
    color: #f3f3f3;
    border: 1px solid #2C2F30 !important;
    background-color: #2C2F30 !important; }
  ul#colors #sepia {
    color: #2c3e50;
    border: 1px solid #dcc1a7 !important;
    background-color: #dcc1a7 !important; }
  .book-content {
    width: 100vw !important;
    min-width: 0 !important;
    margin-top: 50px;
    height: 100vh !important;
    max-height: calc(100vh - 50px); }
    .book-content .rezz {
      display: none; }
    .book-content .book-page {
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important; }
      .book-content .book-page .coverImage, .book-content .book-page .seperator img, .book-content .book-page img {
        page-break-before: auto !important;
        page-break-after: auto !important;
        -webkit-column-break-inside: avoid !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        /*margin-left: 50%;*/
        /*transform: translate(-50%, 0); */
      }
      .book-content .book-page ul > li {
        max-width: 90% !important; }
  .mobile-social-btn {
    display: block;
    width: 20vw; }
    .mobile-social-btn span {
      display: none; }
  .desktop-social-btn {
    display: none; } }

@media only screen and (max-width: 480px) {
  .lib-item-size .input-group {
    width: 150px;
    position: absolute;
    right: 0;
    top: 50px;
    background-color: #f3f3f3;
    box-shadow: 5px 0 15px rgba(0, 0, 0, 0.1), -5px 0 15px rgba(0, 0, 0, 0.1);
    padding: 20px; }
  .settings {
    margin-top: 20px; }
  .columns-setting,
  .width-setting {
    display: none !important; }
  .slider__thumb {
    width: 35px;
    height: 35px;
    border: 1px inset 3px solid #f3f3f3; }
  .book-content {
    height: calc(100vh - 80px) !important;
    width: 100vw !important;
    padding: 0 !important;
    overflow: hide !important;
    overflow-y: scroll !important; }
    .book-content .slide-right-enter-active,
    .book-content .slide-right-leave-active,
    .book-content .slide-left-enter-active,
    .book-content .slide-left-leave-active,
    .book-content .slide-right-enter,
    .book-content .slide-left-leave-to,
    .book-content .slide-right-enter-to,
    .book-content .slide-left-leave,
    .book-content .slide-right-leave,
    .book-content .slide-left-enter-to,
    .book-content .slide-left-enter,
    .book-content .slide-right-leave-to,
    .book-content .book-page {
      font-size: 22px;
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      height: auto !important;
      columns: 220px 1 !important;
      padding: 0;
      margin: 0 !important;
      max-height: 100%; }
      .book-content .slide-right-enter-active .book-content .book-page h1, .book-content .slide-right-enter-active .bookTitle, .book-content .slide-right-enter-active h1,
      .book-content .slide-right-leave-active .book-content .book-page h1,
      .book-content .slide-right-leave-active .bookTitle,
      .book-content .slide-right-leave-active h1,
      .book-content .slide-left-enter-active .book-content .book-page h1,
      .book-content .slide-left-enter-active .bookTitle,
      .book-content .slide-left-enter-active h1,
      .book-content .slide-left-leave-active .book-content .book-page h1,
      .book-content .slide-left-leave-active .bookTitle,
      .book-content .slide-left-leave-active h1,
      .book-content .slide-right-enter .book-content .book-page h1,
      .book-content .slide-right-enter .bookTitle,
      .book-content .slide-right-enter h1,
      .book-content .slide-left-leave-to .book-content .book-page h1,
      .book-content .slide-left-leave-to .bookTitle,
      .book-content .slide-left-leave-to h1,
      .book-content .slide-right-enter-to .book-content .book-page h1,
      .book-content .slide-right-enter-to .bookTitle,
      .book-content .slide-right-enter-to h1,
      .book-content .slide-left-leave .book-content .book-page h1,
      .book-content .slide-left-leave .bookTitle,
      .book-content .slide-left-leave h1,
      .book-content .slide-right-leave .book-content .book-page h1,
      .book-content .slide-right-leave .bookTitle,
      .book-content .slide-right-leave h1,
      .book-content .slide-left-enter-to .book-content .book-page h1,
      .book-content .slide-left-enter-to .bookTitle,
      .book-content .slide-left-enter-to h1,
      .book-content .slide-left-enter .book-content .book-page h1,
      .book-content .slide-left-enter .bookTitle,
      .book-content .slide-left-enter h1,
      .book-content .slide-right-leave-to .book-content .book-page h1,
      .book-content .slide-right-leave-to .bookTitle,
      .book-content .slide-right-leave-to h1,
      .book-content .book-page .book-content .book-page h1,
      .book-content .book-page .bookTitle,
      .book-content .book-page h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important; }
      .book-content .slide-right-enter-active .coverImage, .book-content .slide-right-enter-active .seperator img, .book-content .slide-right-enter-active img,
      .book-content .slide-right-leave-active .coverImage,
      .book-content .slide-right-leave-active .seperator img,
      .book-content .slide-right-leave-active img,
      .book-content .slide-left-enter-active .coverImage,
      .book-content .slide-left-enter-active .seperator img,
      .book-content .slide-left-enter-active img,
      .book-content .slide-left-leave-active .coverImage,
      .book-content .slide-left-leave-active .seperator img,
      .book-content .slide-left-leave-active img,
      .book-content .slide-right-enter .coverImage,
      .book-content .slide-right-enter .seperator img,
      .book-content .slide-right-enter img,
      .book-content .slide-left-leave-to .coverImage,
      .book-content .slide-left-leave-to .seperator img,
      .book-content .slide-left-leave-to img,
      .book-content .slide-right-enter-to .coverImage,
      .book-content .slide-right-enter-to .seperator img,
      .book-content .slide-right-enter-to img,
      .book-content .slide-left-leave .coverImage,
      .book-content .slide-left-leave .seperator img,
      .book-content .slide-left-leave img,
      .book-content .slide-right-leave .coverImage,
      .book-content .slide-right-leave .seperator img,
      .book-content .slide-right-leave img,
      .book-content .slide-left-enter-to .coverImage,
      .book-content .slide-left-enter-to .seperator img,
      .book-content .slide-left-enter-to img,
      .book-content .slide-left-enter .coverImage,
      .book-content .slide-left-enter .seperator img,
      .book-content .slide-left-enter img,
      .book-content .slide-right-leave-to .coverImage,
      .book-content .slide-right-leave-to .seperator img,
      .book-content .slide-right-leave-to img,
      .book-content .book-page .coverImage,
      .book-content .book-page .seperator img,
      .book-content .book-page img {
        max-width: 100vw !important;
        padding-bottom: 100px !important; }
  ::-webkit-scrollbar {
    position: relative;
    width: 5px;
    width: 0; } }

@media only screen and (max-width: 823px) and (max-height: 480px) and (orientation: landscape) {
  .book-content .slide-right-enter-active,
  .book-content .slide-right-leave-active,
  .book-content .slide-left-enter-active,
  .book-content .slide-left-leave-active,
  .book-content .slide-right-enter,
  .book-content .slide-left-leave-to,
  .book-content .slide-right-enter-to,
  .book-content .slide-left-leave,
  .book-content .slide-right-leave,
  .book-content .slide-left-enter-to,
  .book-content .slide-left-enter,
  .book-content .slide-right-leave-to,
  .book-content .book-page {
    padding: 20px; }
    .book-content .slide-right-enter-active .book-content .book-page h1, .book-content .slide-right-enter-active .bookTitle, .book-content .slide-right-enter-active h1,
    .book-content .slide-right-leave-active .book-content .book-page h1,
    .book-content .slide-right-leave-active .bookTitle,
    .book-content .slide-right-leave-active h1,
    .book-content .slide-left-enter-active .book-content .book-page h1,
    .book-content .slide-left-enter-active .bookTitle,
    .book-content .slide-left-enter-active h1,
    .book-content .slide-left-leave-active .book-content .book-page h1,
    .book-content .slide-left-leave-active .bookTitle,
    .book-content .slide-left-leave-active h1,
    .book-content .slide-right-enter .book-content .book-page h1,
    .book-content .slide-right-enter .bookTitle,
    .book-content .slide-right-enter h1,
    .book-content .slide-left-leave-to .book-content .book-page h1,
    .book-content .slide-left-leave-to .bookTitle,
    .book-content .slide-left-leave-to h1,
    .book-content .slide-right-enter-to .book-content .book-page h1,
    .book-content .slide-right-enter-to .bookTitle,
    .book-content .slide-right-enter-to h1,
    .book-content .slide-left-leave .book-content .book-page h1,
    .book-content .slide-left-leave .bookTitle,
    .book-content .slide-left-leave h1,
    .book-content .slide-right-leave .book-content .book-page h1,
    .book-content .slide-right-leave .bookTitle,
    .book-content .slide-right-leave h1,
    .book-content .slide-left-enter-to .book-content .book-page h1,
    .book-content .slide-left-enter-to .bookTitle,
    .book-content .slide-left-enter-to h1,
    .book-content .slide-left-enter .book-content .book-page h1,
    .book-content .slide-left-enter .bookTitle,
    .book-content .slide-left-enter h1,
    .book-content .slide-right-leave-to .book-content .book-page h1,
    .book-content .slide-right-leave-to .bookTitle,
    .book-content .slide-right-leave-to h1,
    .book-content .book-page .book-content .book-page h1,
    .book-content .book-page .bookTitle,
    .book-content .book-page h1 {
      font-size: 30px !important;
      line-height: 33px !important;
      display: inline-block !important; }
  .book-content .book-page {
    padding: 0 0 30px 0; } }

@media screen and (max-width: 1023px) {
  .mobile-buy-btn {
    display: block; }
    .mobile-buy-btn span {
      display: none; } }

@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .book-content .slide-right-enter-active,
  .book-content .slide-right-leave-active,
  .book-content .slide-left-enter-active,
  .book-content .slide-left-leave-active,
  .book-content .slide-right-enter,
  .book-content .slide-left-leave-to,
  .book-content .slide-right-enter-to,
  .book-content .slide-left-leave,
  .book-content .slide-right-leave,
  .book-content .slide-left-enter-to,
  .book-content .slide-left-enter,
  .book-content .slide-right-leave-to,
  .book-content .book-page {
    font-size: 22px;
    overflow-y: hidden;
    page-break-before: auto !important;
    page-break-after: auto !important;
    -webkit-column-break-inside: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    max-height: calc(100vh - 105px) !important;
    columns: 220px 1 !important;
    column-gap: 20px !important;
    padding: 0; }
    .book-content .slide-right-enter-active .book-content .book-page h1, .book-content .slide-right-enter-active .bookTitle, .book-content .slide-right-enter-active h1,
    .book-content .slide-right-leave-active .book-content .book-page h1,
    .book-content .slide-right-leave-active .bookTitle,
    .book-content .slide-right-leave-active h1,
    .book-content .slide-left-enter-active .book-content .book-page h1,
    .book-content .slide-left-enter-active .bookTitle,
    .book-content .slide-left-enter-active h1,
    .book-content .slide-left-leave-active .book-content .book-page h1,
    .book-content .slide-left-leave-active .bookTitle,
    .book-content .slide-left-leave-active h1,
    .book-content .slide-right-enter .book-content .book-page h1,
    .book-content .slide-right-enter .bookTitle,
    .book-content .slide-right-enter h1,
    .book-content .slide-left-leave-to .book-content .book-page h1,
    .book-content .slide-left-leave-to .bookTitle,
    .book-content .slide-left-leave-to h1,
    .book-content .slide-right-enter-to .book-content .book-page h1,
    .book-content .slide-right-enter-to .bookTitle,
    .book-content .slide-right-enter-to h1,
    .book-content .slide-left-leave .book-content .book-page h1,
    .book-content .slide-left-leave .bookTitle,
    .book-content .slide-left-leave h1,
    .book-content .slide-right-leave .book-content .book-page h1,
    .book-content .slide-right-leave .bookTitle,
    .book-content .slide-right-leave h1,
    .book-content .slide-left-enter-to .book-content .book-page h1,
    .book-content .slide-left-enter-to .bookTitle,
    .book-content .slide-left-enter-to h1,
    .book-content .slide-left-enter .book-content .book-page h1,
    .book-content .slide-left-enter .bookTitle,
    .book-content .slide-left-enter h1,
    .book-content .slide-right-leave-to .book-content .book-page h1,
    .book-content .slide-right-leave-to .bookTitle,
    .book-content .slide-right-leave-to h1,
    .book-content .book-page .book-content .book-page h1,
    .book-content .book-page .bookTitle,
    .book-content .book-page h1 {
      font-size: 40px !important;
      line-height: 45px !important;
      display: inline-block !important; } }

@media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
  .book-content .slide-right-enter-active,
  .book-content .slide-right-leave-active,
  .book-content .slide-left-enter-active,
  .book-content .slide-left-leave-active,
  .book-content .slide-right-enter,
  .book-content .slide-left-leave-to,
  .book-content .slide-right-enter-to,
  .book-content .slide-left-leave,
  .book-content .slide-right-leave,
  .book-content .slide-left-enter-to,
  .book-content .slide-left-enter,
  .book-content .slide-right-leave-to,
  .book-content .book-page {
    font-size: 22px;
    overflow-y: hidden;
    page-break-before: auto !important;
    page-break-after: auto !important;
    -webkit-column-break-inside: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    max-height: calc(100vh - 85px) !important;
    columns: 220px 1 !important;
    column-gap: 20px !important;
    padding: 0; }
    .book-content .slide-right-enter-active .book-content .book-page h1, .book-content .slide-right-enter-active .bookTitle, .book-content .slide-right-enter-active h1,
    .book-content .slide-right-leave-active .book-content .book-page h1,
    .book-content .slide-right-leave-active .bookTitle,
    .book-content .slide-right-leave-active h1,
    .book-content .slide-left-enter-active .book-content .book-page h1,
    .book-content .slide-left-enter-active .bookTitle,
    .book-content .slide-left-enter-active h1,
    .book-content .slide-left-leave-active .book-content .book-page h1,
    .book-content .slide-left-leave-active .bookTitle,
    .book-content .slide-left-leave-active h1,
    .book-content .slide-right-enter .book-content .book-page h1,
    .book-content .slide-right-enter .bookTitle,
    .book-content .slide-right-enter h1,
    .book-content .slide-left-leave-to .book-content .book-page h1,
    .book-content .slide-left-leave-to .bookTitle,
    .book-content .slide-left-leave-to h1,
    .book-content .slide-right-enter-to .book-content .book-page h1,
    .book-content .slide-right-enter-to .bookTitle,
    .book-content .slide-right-enter-to h1,
    .book-content .slide-left-leave .book-content .book-page h1,
    .book-content .slide-left-leave .bookTitle,
    .book-content .slide-left-leave h1,
    .book-content .slide-right-leave .book-content .book-page h1,
    .book-content .slide-right-leave .bookTitle,
    .book-content .slide-right-leave h1,
    .book-content .slide-left-enter-to .book-content .book-page h1,
    .book-content .slide-left-enter-to .bookTitle,
    .book-content .slide-left-enter-to h1,
    .book-content .slide-left-enter .book-content .book-page h1,
    .book-content .slide-left-enter .bookTitle,
    .book-content .slide-left-enter h1,
    .book-content .slide-right-leave-to .book-content .book-page h1,
    .book-content .slide-right-leave-to .bookTitle,
    .book-content .slide-right-leave-to h1,
    .book-content .book-page .book-content .book-page h1,
    .book-content .book-page .bookTitle,
    .book-content .book-page h1 {
      font-size: 40px !important;
      line-height: 45px !important;
      display: inline-block !important; } }

@media only screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) {
  .book-content .slide-right-enter-active,
  .book-content .slide-right-leave-active,
  .book-content .slide-left-enter-active,
  .book-content .slide-left-leave-active,
  .book-content .slide-right-enter,
  .book-content .slide-left-leave-to,
  .book-content .slide-right-enter-to,
  .book-content .slide-left-leave,
  .book-content .slide-right-leave,
  .book-content .slide-left-enter-to,
  .book-content .slide-left-enter,
  .book-content .slide-right-leave-to,
  .book-content .book-page {
    font-size: 22px;
    overflow-y: hidden;
    page-break-before: auto !important;
    page-break-after: auto !important;
    -webkit-column-break-inside: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    max-height: calc(100vh - 85px) !important;
    columns: 220px 1 !important;
    column-gap: 20px !important;
    padding: 0; }
    .book-content .slide-right-enter-active .book-content .book-page h1, .book-content .slide-right-enter-active .bookTitle, .book-content .slide-right-enter-active h1,
    .book-content .slide-right-leave-active .book-content .book-page h1,
    .book-content .slide-right-leave-active .bookTitle,
    .book-content .slide-right-leave-active h1,
    .book-content .slide-left-enter-active .book-content .book-page h1,
    .book-content .slide-left-enter-active .bookTitle,
    .book-content .slide-left-enter-active h1,
    .book-content .slide-left-leave-active .book-content .book-page h1,
    .book-content .slide-left-leave-active .bookTitle,
    .book-content .slide-left-leave-active h1,
    .book-content .slide-right-enter .book-content .book-page h1,
    .book-content .slide-right-enter .bookTitle,
    .book-content .slide-right-enter h1,
    .book-content .slide-left-leave-to .book-content .book-page h1,
    .book-content .slide-left-leave-to .bookTitle,
    .book-content .slide-left-leave-to h1,
    .book-content .slide-right-enter-to .book-content .book-page h1,
    .book-content .slide-right-enter-to .bookTitle,
    .book-content .slide-right-enter-to h1,
    .book-content .slide-left-leave .book-content .book-page h1,
    .book-content .slide-left-leave .bookTitle,
    .book-content .slide-left-leave h1,
    .book-content .slide-right-leave .book-content .book-page h1,
    .book-content .slide-right-leave .bookTitle,
    .book-content .slide-right-leave h1,
    .book-content .slide-left-enter-to .book-content .book-page h1,
    .book-content .slide-left-enter-to .bookTitle,
    .book-content .slide-left-enter-to h1,
    .book-content .slide-left-enter .book-content .book-page h1,
    .book-content .slide-left-enter .bookTitle,
    .book-content .slide-left-enter h1,
    .book-content .slide-right-leave-to .book-content .book-page h1,
    .book-content .slide-right-leave-to .bookTitle,
    .book-content .slide-right-leave-to h1,
    .book-content .book-page .book-content .book-page h1,
    .book-content .book-page .bookTitle,
    .book-content .book-page h1 {
      font-size: 40px !important;
      line-height: 45px !important;
      display: inline-block !important; } }

</style>


// WEBPACK FOOTER //
// App.vue?4742aa2b